
export const getArray = (itemOrArray) => {
    if (!itemOrArray) return [];
    return typeof itemOrArray === "object" ? itemOrArray : [itemOrArray]
}